import React from 'react'
import SupplierContainer from '../../../../../Components/UserPart/UserList/SupplierContainer/SupplierContainer'
import Layout from '../../../Layout'

const Supplier = () => {
  return (
    <Layout>
        <SupplierContainer/>
    </Layout>
  )
}

export default Supplier